export type OfferCardFields =
  | 'title'
  | 'job_id'
  | 'department'
  | 'location'
  | 'qualified_candidates'
  | 'disqualified_candidates'
  | 'new_candidates'
  | 'hires'
  | 'scheduled_publish_date'
  | 'scheduled_close_date'
  | 'work_model'
  | 'manage'
  | 'priority';

/**
 * To be removed when views jobs will replace current jobs list
 */
export const offerCardVisibleFieldsFallback = <Record<OfferCardFields, boolean>>(
  new Proxy({}, { get: () => true })
);
